import { currentFeatures } from "@/configs/Settings";

/**
 * isVetApp
 *
 * Fonte de verdade simples para decidir se o fluxo deve operar em "modo vet".
 *
 * Preferimos um sinal explícito por ENV para evitar heurísticas frágeis (ex.: URL).
 * Fallback: quando a env não estiver definida, assumimos "vet" porque o `src-next`
 * já opera com headers/padrões de integração voltados ao FluxVet.
 */
export function isVetApp() {
  return currentFeatures.defaultApp ? false : true;
}
